module.exports = __webpack_public_path__ + "img/pdf.3139a448.png";